import Header from 'components/Headers/Header';
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useGlobalFilter } from 'react-table';
import { Card, Table, Container, Row } from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { GlobalFilter } from 'components/Generic/GlobalFilter';
import { ActionPopover } from 'components/Table/ActionTable';
import { showDateFormated } from 'utility/generic';

export function TableGeneric({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
  );

  const { globalFilter } = state;

  return (
    <>
      <GlobalFilter
        filter={globalFilter}
        setFilter={setGlobalFilter}
        urlNewItem={'/route/new'}
      />
      <Table responsive striped hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ fontSize: '18px' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length !== 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} style={{ fontSize: '18px' }}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '18px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Não há registros disponíveis, por gentileza cadastre uma rota!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
}

export const RouteList = () => {
  const [route, setRoute] = useState([]);

  useEffect(() => {
    async function getData() {
      const data = await handleSendGeneric('/v1/route', 'GET');
      if (data !== undefined) {
        setRoute(data);
      }
    }

    getData();
  }, []);

  const cacheItemsDisabled = useMemo(() => route, [route]);

  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'id',
      },
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Habilitado',
        accessor: 'enable',
        Cell: ({ cell: { value } }) => (
          <span>{`${value === true ? 'Sim' : 'Não'}`}</span>
        ),
      },
      {
        Header: 'Última Atualização',
        accessor: 'lastUpdate',
        Cell: ({ cell: { value } }) => (
          <span>{`${showDateFormated(value)}`}</span>
        ),
      },
      {
        Header: 'Ação',
        Cell: ({ ...props }) => {
          const actionId = props.data[props.row.index]?.id;
          return (
            <ActionPopover
              urlEdit={'/route/' + actionId}
              urlDelete={'/v1/route/'}
              idDelete={actionId}
              listUpdate={setRoute}
              enableModal
            />
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <Header />
      <Container className='mt--7' fluid>
        <Row>
          <div className='col'>
            <Card className='shadow'>
              <TableGeneric columns={columns} data={cacheItemsDisabled} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
